import { memo, useEffect, useState } from "react";
import { useMe } from "@/data/user.ts";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import ROUTES from "@/config/routes.ts";
import useAuth from "@/utils/hooks/useAuth.ts";
// import PageLoader from "@edusogno/composites/page-loader";
import languageMenu from "@/utils/i18n/locales";
import BaseAuthLayout from "@edusogno/layouts/auth-layout";
import { easypeasyWhiteLogo } from "@/utils/logo-uris";
const EDS_BASE_ROUTE = import.meta.env.EDS_BASE_ROUTE;

const AuthLayout = memo(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const { i18n } = useTranslation();
  const { authorize } = useAuth();
  const { token: authTk } = useParams();
  const { resolvedLanguage } = i18n;
  const { me, isAuthorized } = useMe();
  const lang = i18n.language;
  const isItalian = ["it"].includes(lang);
  const isUser = !!(me && me.status === 200);

  const [selectedItem, setSelectedItem] = useState<string>();

  useEffect(() => {
    const currentlySelectedItem = resolvedLanguage
      ? languageMenu.find((o) => o?.value === resolvedLanguage)!
      : languageMenu[2];

    setSelectedItem(currentlySelectedItem?.value);
  }, [resolvedLanguage]);

  useEffect(() => {
    if (authTk && location.pathname.includes(EDS_BASE_ROUTE + "impersonate/")) {
      authorize(authTk);
      navigate(ROUTES.home, { replace: true });
      return;
    } else if (isUser && isAuthorized && location.pathname === EDS_BASE_ROUTE) {
      navigate(ROUTES.home, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isUser, isAuthorized, location.pathname, authTk]);

  // if (!isUser && !isAuthorized) {
  return (
    <BaseAuthLayout
      language={selectedItem}
      languageOptions={languageMenu.map((r) => ({
        label: r.name,
        value: r.value,
      }))}
      onChangeLanguage={(currentValue) => {
        setSelectedItem(currentValue);
        void i18n.changeLanguage(currentValue);
      }}
      logoUrl={!isItalian ? easypeasyWhiteLogo : ""}
    >
      <Outlet />
    </BaseAuthLayout>
  );
  // }

  // return <PageLoader />;
});

export default AuthLayout;
